// Function to split elements into column having of max column size of specified parameter value
// and to create some equal sizes columns
export function splitItemsIntoColumns(items: Array<any>, maxColumnSize: number) {
  const columnCount = Math.ceil(items.length / maxColumnSize); // Calculate the number of columns needed
  const itemsPerColumn = Math.ceil(items.length / columnCount); // Calculate the number of items per column
  const columns = [];

  for (let i = 0; i < columnCount; i++) {
    const columnItems = items.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn);
    columns.push(columnItems);
  }

  return columns;
}
